import { render } from "./ConsultingSchoolAddModal.vue?vue&type=template&id=ce99f6fa&scoped=true"
import script from "./ConsultingSchoolAddModal.vue?vue&type=script&lang=js"
export * from "./ConsultingSchoolAddModal.vue?vue&type=script&lang=js"

import "./ConsultingSchoolAddModal.vue?vue&type=style&index=0&id=ce99f6fa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce99f6fa"]])

export default __exports__